<template>
  <div class="width-100 padding-Tb-20 bg-img">
    <img src="../../../assets/image/yfns/20.png" width="100%" alt="" />
    <div class="width-100 padding-lr margin-t">
      <div class="question-box position-relative">
        <div class="width-100 title-img flex-row justify-content-spaceBetween align-items-center">
          <img class="" src="../../../assets/image/yfns/16.png" width="20%" alt="" />
          <div class="num margin-t din">{{ questionIndex + 1 }}/8</div>
        </div>
        <template v-if="questionShow">
          <div class="fs-mid margin-b line-height title padding-lr" v-html="questionArr[questionIndex].title"></div>
          <div
            class="padding-lr"
            @click="current = answerIndex"
            v-for="(answerItem, answerIndex) in questionArr[questionIndex].options"
            :key="answerIndex"
          >
            <div
              class="fs-mid margin-b answer-box"
              :class="{
                'select-right': answerIndex == current && answerItem.is_right == 'Y',
                'select-wrong': answerIndex == current && answerItem.is_right == 'N'
              }"
              @click="checkOption(answerIndex, answerItem)"
            >
              {{ charArr[answerIndex] }}.{{ answerItem.val }}
            </div>
          </div>
        </template>
        <img class="bottom-img" src="../../../assets/image/yfns/13.png" width="30%" alt="" />
      </div>
    </div>

    <div class="width-100 flex-column justify-content-center align-items-center margin-t">
      <img class="margin-b" width="40%" src="~@/assets/image/yfns/14.png" alt="" @click="doNext()" v-if="showNextBtn" />
      <img @click="doPrice" class="margin-b" width="40%" src="~@/assets/image/yfns/12.png" alt="" v-if="showSubmitBtn" />
    </div>
    <img class="margin-t" width="100%" src="~@/assets/image/yfns/8.png" alt="" />

    <van-popup class="width-80" v-model="show" closeable close-icon="close" close-on-click-overlay>
      <div class="width-100 pop-box2 flex-column justify-content-around align-items-center">
        <img src="@/assets/image/yfns/3.png" class="" width="100%" alt="" />
        <img src="@/assets/image/yfns/10.png" @click="doSubmit" class="margin-ts" width="40%" alt="" />
      </div>
    </van-popup>

    <!--    规则-->
    <img class="fixed-right" @click="showRule = true" src="../../../assets/image/yfns/6.png" width="6%" alt="" />
    <van-popup v-model="showRule" class="width-85 popup-box">
      <img src="../../../assets/image/yfns/19.png" width="100%" alt="" />
    </van-popup>
  </div>
</template>
<script>
import { getQuestionsList } from '@/api/act/commonApi';
import { Dialog, Toast } from 'vant';
import { raxwRaffle, userPrice, zlbRaffle } from '@/api/act/yfnsApi';

export default {
  name: '',
  data() {
    return {
      hasPrice: false,
      maxNum: 8,
      current: -1,
      show: false,
      showRule: false,
      showNextBtn: false,
      showSubmitBtn: false,
      questionShow: false,
      questionIndex: 0,
      questionArr: [],
      charArr: ['A', 'B', 'C', 'D', 'E', 'F']
    };
  },
  created() {
    this.loadQuestion();
    this.checkHasPrice();
  },
  mounted() {},
  methods: {
    loadQuestion() {
      getQuestionsList(24, { size: this.maxNum }).then((res) => {
        if (res.code === 0) {
          this.questionShow = true;
          this.questionArr = res.list;
        }
      });
    },
    checkOption(i, o) {
      this.current = i;
      if (o.is_right === 'Y') {
        if (this.questionIndex + 1 >= this.maxNum) {
          this.showNextBtn = false;
          this.showSubmitBtn = true;
        } else {
          this.showNextBtn = true;
          this.showSubmitBtn = false;
        }
      } else {
        this.showNextBtn = false;
        this.showSubmitBtn = false;
      }
    },
    doNext() {
      this.questionIndex++;
      this.current = -1;
      this.showNextBtn = false;
      this.showSubmitBtn = false;
    },
    checkHasPrice() {
      let that = this;
      userPrice({
        wxId: sessionStorage.getItem('wxId'),
        zlbUserId: sessionStorage.getItem('zlbUserId'),
        raxwId: sessionStorage.getItem('raxwId')
      }).then((res) => {
        if (res.code === 0) {
          if (res.data) {
            that.hasPrice = true;
          } else {
            that.hasPrice = false;
          }
        } else {
          Toast.fail('加载失败,请刷新重试');
        }
      });
    },
    doPrice() {
      if (this.hasPrice) {
        Dialog.alert({
          title: '提示',
          message: '您已中过奖品，点击确认前往查看奖品'
        }).then(() => {
          this.$router.replace('cj');
        });
      } else {
        this.show = true;
      }
    },
    doSubmit() {
      if (sessionStorage.getItem('raxwId')) {
        raxwRaffle({ raxwId: sessionStorage.getItem('raxwId') }).then((res) => {
          if (res.code === 0) {
            this.$router.push('cj');
          } else if (res.code === 409) {
            Dialog.alert({
              title: '提示',
              message: '您已中过奖品，点击确认前往查看奖品'
            }).then(() => {
              this.$router.replace('cj');
            });
          } else {
            Toast.fail(res.msg);
          }
        });
      } else if (sessionStorage.getItem('zlbUserId')) {
        zlbRaffle({ zlbUserId: sessionStorage.getItem('zlbUserId') }).then((res) => {
          if (res.code === 0) {
            this.$router.push('cj');
          } else if (res.code === 409) {
            Dialog.alert({
              title: '提示',
              message: '您已中过奖品，点击确认前往查看奖品'
            }).then(() => {
              this.$router.replace('cj');
            });
          } else {
            Toast.fail(res.msg);
          }
        });
      } else if (sessionStorage.getItem('wxId')) {
        this.$router.push('jg');
      } else {
        Toast.fail('网络异常,请刷新重试');
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/yfns/common.css';
@import '../../../assets/css/yfns/demo1.css';
@import '../../../assets/css/yfns/demo2.css';
.bg-img {
  min-height: 100vh;
  background: rgb(56, 162, 77) url('../../../assets/image/yfns/bg1.jpg') round no-repeat;
  background-size: 100%;
}
.question-box {
  padding: 20px 5% 20px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 10px;
  box-shadow: 0 0 20px 0 rgba(14, 101, 223, 0.5);
}

.num {
  top: -30px;
  color: #237be7;
  font-size: 1rem;
}
.label {
  background: rgb(210, 225, 249);
  padding: 2px 8px;
  color: rgb(101, 158, 241);
}
.title {
  border-bottom: 1px solid #237be7;
  padding-bottom: 20px;
}
.title-img {
  position: relative;
  top: -27px;
}
.answer-box {
  padding: 12px 35px 12px 15px;
  line-height: 24px;
  color: #333333;
  background: #ffffff;
  border: 1px solid #b6daff;
  border-radius: 50px;
  text-align: justify;
}

.select-right {
  background: url('../../../assets/image/yfns/17.png') #237be7 no-repeat right 5% center;
  background-size: 20px;
  color: #ffffff;
}

.select-wrong {
  background: url('../../../assets/image/yfns/1.png') #e74242 no-repeat right 5% center;
  background-size: 20px;
  color: #ffffff;
}
.bottom-img {
  position: absolute;
  bottom: -95px;
  left: -6%;
}

/deep/.van-popup {
  background-color: rgba(0, 0, 0, 0);
}
/deep/.van-popup__close-icon {
  top: 1px;
  right: 0;
}

.pop-box2 {
  height: 250px;
}
</style>
